"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTestUser = void 0;
const sillyname_1 = __importDefault(require("sillyname"));
const uuid_1 = require("uuid");
/**
 * Create a new user object with a unique id
 * ({@link https://en.wikipedia.org/wiki/Universally_unique_identifier | uuid}) and random name (FIRST LAST)
 *
 * @returns a user object with a name and id property
 */
const generateTestUser = () => {
    const user = {
        id: (0, uuid_1.v4)(),
        name: (0, sillyname_1.default)(),
    };
    return user;
};
exports.generateTestUser = generateTestUser;
//# sourceMappingURL=generateTestUser.js.map